import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";

export default function Testimonials() {
  const items = [...TESTIMONIALS, ...TESTIMONIALS]; // duplicate for marquee
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-white border-y border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-16 md:py-24">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#0369A1]">
            Patient Voices
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B2545]">
            Trusted by families across Bangalore.
          </h2>
        </div>
      </div>

      <div className="marquee relative overflow-hidden pb-16 md:pb-24">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="marquee-track flex gap-6 w-max">
          {items.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#F8FAFC] border border-gray-100 rounded-2xl p-6 md:p-7 w-[320px] sm:w-[380px] shrink-0"
            >
              <Quote className="w-7 h-7 text-[#14B8A6]" />
              <p className="mt-4 text-[#0B2545] leading-relaxed text-[15px]">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <div className="font-display font-bold text-[#0B2545]">{t.name}</div>
                  <div className="text-xs text-[#64748B]">{t.role}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="w-4 h-4 fill-[#F59E0B] text-[#F59E0B]" />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
